module.exports = __webpack_public_path__ + "media/cash-register.c7bbbc94.mp3";